import useLoggedInSession from './useLoggedInSession'
import { UserType } from '../../types'

function useUser(): UserType {
  const { user } = useLoggedInSession()

  return user
}

export default useUser
